import { Controller } from "@hotwired/stimulus";

// Applies one loading contract to every Turbo form without changing its label.
// Button elements may include .ui-button__spinner; native submit inputs still
// receive the same busy, disabled, and cursor states.
export default class extends Controller {
  connect() {
    this.boundPrepareSubmit = this.prepareSubmit.bind(this);
    this.element.addEventListener("submit", this.boundPrepareSubmit, true);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundPrepareSubmit, true);
  }

  prepareSubmit(event) {
    // Turbo's replacement text removes context (for example, changing "Save
    // role" to only "Saving..."). The shared busy treatment communicates the
    // state while preserving the action label.
    delete event.submitter?.dataset.turboSubmitsWith;
  }

  submitStart(event) {
    const submitter = event.detail?.formSubmission?.submitter;
    if (!submitter) return;

    submitter.dataset.loading = "true";
    submitter.setAttribute("aria-busy", "true");
    submitter.disabled = true;
  }

  submitEnd(event) {
    const submitter = event.detail?.formSubmission?.submitter;
    if (!submitter) return;

    delete submitter.dataset.loading;
    submitter.removeAttribute("aria-busy");
    submitter.disabled = false;
  }
}
